// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Health check'">
    <div class="right-header-panel">
      <div class="switch">
        <input id="hide-healthy-switch" type="checkbox" ng-model="\$ctrl.hideOk"/>
        <label for="hide-healthy-switch">Hide OK</label>
      </div>
      <button type="button" class="btn btn-success" ng-click="\$ctrl.refetchHealthChecks()">{{\$ctrl.refreshButtonName}}</button>
    </div>
  </sub-header>
  <div class="empty-message" ng-if="!\$ctrl.checks">
    <span>Press {{\$ctrl.refreshButtonName}} to update data.</span>
  </div>
  <div ng-if="\$ctrl.checks && \$ctrl.healthCheckPhase">
    <health-check-list checks="\$ctrl.checks" hide-ok="\$ctrl.hideOk" phase-type="\$ctrl.healthCheckPhase"></health-check-list>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/system-health-check/system-health-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;